import { DRAG_TYPES } from '../constants/dnd';
import { getPegboardItemDimension, getPegboardItemOffset } from '../geometry/pegboard';
export function isExistingItemDragItem(dragItem) {
  return dragItem.type === DRAG_TYPES.EXISTING_ITEM ||
  // @ts-expect-error - dragType is a fallback for CEUI, and won't be needed in Editor 2.0
  dragItem.dragType === DRAG_TYPES.EXISTING_ITEM;
}
export function getDropTargetIndexWithinPegboardBounds(hoveredIndex, hoveredSize, pegboardSize) {
  // Hovered index is 0-based, so we need to add 1 since drop targets are 1-based
  const atLeastOne = Math.max(hoveredIndex + 1, 1);
  const withinPegboardBounds = Math.min(atLeastOne, pegboardSize - hoveredSize + 1);
  return withinPegboardBounds;
}

/**
 * Returns the computed row or column spanning for a given element.
 * Defaults to the max pegboard dimension if the element's size exceeds the
 * pegboard's size.
 *
 * @param elementSize
 * @param pegboardSize
 * @param maxPegboardRowsOrColumns
 */
export function getDragPreviewComputedPegboardSpanning({
  elementSize,
  pegboardCellSize,
  maxPegboardCells
}) {
  const computedElementSpan = Math.ceil(elementSize / pegboardCellSize);
  return Math.min(computedElementSpan, maxPegboardCells);
}
export function getDropTargetPositionAndBounds({
  targetRow,
  targetColumn,
  pegboardNodePosition,
  dragItemNodePosition
}) {
  const {
    top: pegboardTop,
    left: pegboardLeft,
    rowSize,
    columnSize,
    rowGap,
    columnGap
  } = pegboardNodePosition;
  const {
    height: elementHeight,
    width: elementWidth,
    rowsSpanned,
    columnsSpanned
  } = dragItemNodePosition;
  const top = pegboardTop + getPegboardItemOffset(rowSize, rowGap, targetRow);
  const left = pegboardLeft + getPegboardItemOffset(columnSize, columnGap, targetColumn);

  // TODO: Two spanned rows and 4 spanned columns are temporary defaults
  // until we start assigning defaults at a module level.
  const spannedColumns = columnsSpanned || Math.ceil(elementWidth / columnSize) || 4;
  const spannedRows = rowsSpanned || Math.ceil(elementHeight / rowSize) || 2;
  const width = getPegboardItemDimension(columnSize, columnGap, spannedColumns);
  const height = getPegboardItemDimension(rowSize, rowGap, spannedRows);
  return {
    top,
    left,
    width,
    height
  };
}